import { createSlice } from "@reduxjs/toolkit";

const SUPPORTED_LANGUAGES = ["hi", ""];
const DEFAULT_LANGUAGE = "hi";

const getInitialLanguage = () => {
  const stored = localStorage.getItem("languageType");
  return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
};

const getCurrentDate = () => {
  const date = new Date();
  return date.toISOString().split("T")[0]; // Returns the date in YYYY-MM-DD format
};

const initialState = {
  fontSize: 16,
  loading: false,
  languageType: getInitialLanguage(),
  error: "",
  powerTabStr: "hydro",
  reportTabStr: "annual-report",
  reservoirTabs: "Water Levels",
  amritTabStr: "painting-competition",
  filteredDate: getCurrentDate(),
  submitDate: getCurrentDate(),
  lastUpdated: "",
  searchResults: [],
  searchInputValue: "",
  csrActiveTab: "introduction",
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    fontSizeIncrease: (state) => {
      state.fontSize += 1;
    },
    fontSizeDecrease: (state) => {
      state.fontSize -= 1;
    },
    fontSizeOriginal: (state) => {
      state.fontSize = 16;
    },
    setLanguageType: (state, action) => {
      if (!SUPPORTED_LANGUAGES.includes(action.payload)) return;
      state.languageType = action.payload;
      localStorage.setItem("languageType", action.payload);
    },
    setPowerTabStr: (state, action) => {
      state.powerTabStr = action.payload;
    },
    setReservoirsTabStr: (state, action) => {
      state.reservoirTabs = action.payload;
    },

    setReportsTabStr: (state, action) => {
      state.reportTabStr = action.payload;
    },
    setCompetitionsTabStr: (state, action) => {
      state.amritTabStr = action.payload;
    },
    setFilteredDate: (state, action) => {
      state.filteredDate = action.payload;
    },
    setSubmitDate: (state, action) => {
      state.submitDate = action.payload;
    },
    setLastUpdated: (state, action) => {
      state.lastUpdated = action.payload;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setSearchInputValue: (state, action) => {
      state.searchInputValue = action.payload;
    },
    resetSearch: (state) => {
      state.searchInputValue = "";
    },
    resetSubmitDate: (state) => {
      state.submitDate = "";
    },
    setCsrActiveTab: (state, action) => {
      state.csrActiveTab = action.payload;
    },
  },
});

export const {
  fontSizeIncrease,
  fontSizeDecrease,
  fontSizeOriginal,
  setPowerTabStr,
  setLanguageType,
  setFilteredDate,
  setSubmitDate,
  setLastUpdated,
  setReportsTabStr,
  setCompetitionsTabStr,
  setReservoirsTabStr,
  setSearchResults,
  setSearchInputValue,
  resetSearch,
  resetSubmitDate,
  setCsrActiveTab,
} = homeSlice.actions;
export default homeSlice.reducer;
